import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { StatusBadge, PipelineProgress, EmptyState } from "../../components/shared";
import { Plus } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();
  const [projects, setProjects] = useState(null);

  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([])); }, []);

  return (
    <div data-testid="author-dashboard">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-neutral-900 font-heading">My Books</h1>
          <p className="text-neutral-500 mt-1">Welcome back, {user?.name?.split(" ")[0]}</p>
        </div>
        <Link to="/projects/new" data-testid="new-project-button"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-white bg-neutral-900 hover:bg-neutral-800 font-medium text-sm transition-colors">
          <Plus size={16} /> New Submission
        </Link>
      </div>

      {projects === null ? (
        <p className="text-neutral-500">Loading...</p>
      ) : projects.length === 0 ? (
        <EmptyState
          image="https://images.pexels.com/photos/9572522/pexels-photo-9572522.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          title="Your bookshelf is empty"
          subtitle="Submit your first manuscript and we'll take it from draft to self published on Amazon."
          action={<Link to="/projects/new" data-testid="empty-state-new-project" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-white bg-neutral-900 hover:bg-neutral-800 font-medium text-sm">Start a submission</Link>}
        />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p) => (
            <Link key={p.id} to={`/projects/${p.id}`} data-testid={`project-card-${p.id}`}
              className="bg-white border border-neutral-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow block">
              <div className="flex items-start justify-between gap-3 mb-3">
                <h3 className="font-semibold text-neutral-900 font-heading text-lg leading-snug">{p.title}</h3>
                <StatusBadge status={p.status} />
              </div>
              {p.subtitle && <p className="text-sm text-neutral-500 mb-3">{p.subtitle}</p>}
              <PipelineProgress status={p.status} />
              <div className="flex justify-between items-center mt-4 text-xs text-neutral-400">
                <span>{p.genre || "—"}</span>
                <span>{p.plan_name ? `${p.plan_name} plan` : "Not paid yet"}</span>
              </div>
              {p.status === "live" && p.amazon_url && (
                <p className="text-xs text-emerald-700 mt-2 font-medium">Live on Amazon 🎉</p>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
